import React, { useEffect } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Box, Grid, Typography } from "@mui/material";
import ArrowBackIosRoundedIcon from "@mui/icons-material/ArrowBackIosRounded";
import { getBillingConsolidatedInvoiceDetails, getBillingInvoiceDetails, getConsolidateInvoiceMatrix } from "redux/actions/BillingAction";
import Loader from "components/loader/Loader";
import { consolidateInvoiceData } from "./BillingInvoiceData";
import BillingConsolidatedInvoiceTable from "./BillingConsolidatedInvoiceTable";

const BillingConsolidateInvoice = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  const pathName = location?.pathname?.split("/");
  const [searchParams] = useSearchParams();

  const params = Object.fromEntries([...searchParams]);

  const queryParams = {
    cityId: params?.cityId || "",
    cityName: params?.cityName || "",
    companyId: params?.companyId || "",
    companyName: params?.companyName || "",
    tripId: params?.tripId || "",
    page: params?.page || "",
    pageRowSize: params?.pageRowSize || "",
    status: params?.status || "",
    fromDate: params?.fromDate === "undefined" ? "" : params?.fromDate ? params?.fromDate : "",
    toDate: params?.fromDate === "undefined" ? ""  : params?.toDate ? params?.toDate : "",
    magicToken: params?.magicToken || "",
    pageType: params?.pageType || ""
  }
  const consolidationInvoiceMatrix = useSelector((state) => state?.getConsolidateInvoiceMatrix?.consolidateInvoiceMatrix?.data);
  const consolidateInvoiceDetails = consolidateInvoiceData(consolidationInvoiceMatrix);
  const consolidateIvoiceList = useSelector((state) => state?.getBillingConsolidatedInvoiceDetails?.bilingConsolidatedInvoice?.data)
  const consolidateIvoiceLoader = useSelector((state) => state?.getBillingConsolidatedInvoiceDetails?.loading)

  useEffect(() => {

    if (pathName?.includes("operation")) {
      dispatch(getBillingConsolidatedInvoiceDetails(queryParams?.magicToken || queryParams?.tripId))
      dispatch(getConsolidateInvoiceMatrix(queryParams?.magicToken || queryParams?.tripId))
    } else {
      dispatch(getBillingConsolidatedInvoiceDetails(queryParams?.magicToken ,"public"))
      dispatch(getConsolidateInvoiceMatrix(queryParams?.magicToken,"public"))
    }
  }, [])

  const commonGridRender = (arrayData, borderType, gridSize) => {
    return (
      <Grid item md={gridSize?.md} className={`${borderType === "borderRight" && "solidBorderRight1p"} p20`}>
        {arrayData &&
          arrayData?.map((data, idx) => (
            <Grid container key={idx} className="pb20">
              <Grid item xs={6} className="pr20">
                <Typography
                  variant="body4"
                  component={"p"}
                  className="colorGrey"
                >
                  {data?.title}
                </Typography>
              </Grid>
              <Grid item xs={6} className="pl20">
                <Typography
                  variant="body4"
                  component={"p"}
                  className="colorBlack"
                >
                  {data?.value}
                </Typography>
              </Grid>
            </Grid>
          ))}
      </Grid>
    );
  };

  return (
    <Grid container className="pt20 br20" justifyContent={"center"}>
      {consolidateIvoiceLoader ? (
        <Loader />
      ) : (
        <Grid item md={11}>
          <Box className="alignStart">
          {pathName?.includes("operation") && (
            <ArrowBackIosRoundedIcon
              className="font24 colorGrey mb20"
              role="presentation"
              onClick={() => navigate(`/operation/billing/billToCompany?companyId=${queryParams?.companyId}&companyName=${queryParams?.companyName}&cityId=${queryParams?.cityId}&cityName=${queryParams?.cityName}&status=${queryParams?.status}&page=${queryParams?.page}&pageRowSize=${queryParams?.pageRowSize}&fromDate=${queryParams?.fromDate}&toDate=${queryParams?.toDate}`)}
            />
          )}
          </Box>
          <Grid
            container
            className="commonBorder br20 mb40 solidBorderBottom1p"
          >
            <Grid container item xs={12} md={9}>
              <Grid
                container
                item
                xs={12}
                className="solidBorderBottom1p solidBorderRight1p"
              >
                <Grid item md={4} className="solidBorderRight1p"></Grid>
                <Grid item md={4} className="solidBorderRight1p">
                  {/* TODO: Api is pending from backend, so currently we are using static data*/}
                  <Typography
                    className="colorPrimary ptb20 textCenter"
                    component={"p"}
                  >
                  {consolidationInvoiceMatrix?.supplierCompanyName || ""} Tax Invoice
                  </Typography>
                </Grid>
                <Grid item md={4}>
                  <Typography
                    className="colorPrimary ptb20 textCenter"
                    component={"p"}
                  >
                    Original For Recipient
                  </Typography>
                </Grid>
              </Grid>
              <Grid
                container
                item
                xs={12}
                className="solidBorderBottom1p solidBorderRight1p"
              >
                <Grid item md={4} className="solidBorderRight1p">
                  <Typography
                    className="colorBlack ptb20 pl20"
                    component={"p"}
                    variant="body4"
                  >
                    Billing Branch
                  </Typography>
                </Grid>
                <Grid item md={8} className="p20">
                  <Typography className="colorBlack" variant="body4">
                    G-6, Ground Floor, Everest Grande, Shanti Nagar, Mahakali
                    Caves Road, Address Andheri (East), Mumbai - 400 093.
                  </Typography>
                </Grid>
              </Grid>
              {commonGridRender(
                consolidateInvoiceDetails?.companyAckDetails,
                "borderRight",
                { md: 6 }
              )}

              {commonGridRender(
                consolidateInvoiceDetails?.companyCinDetails,
                "borderRight",
                { md: 6 }
              )}
            </Grid>

            <Grid className="justifyCenter" item xs={12} md={3}>
              <Box className="wh180">
                
              </Box>
            </Grid>

            <Grid container className="solidBorderTop1p">
              {commonGridRender(
                consolidateInvoiceDetails?.companyDetails,
                "borderRight",
                { md: 4.5 }
              )}

              {commonGridRender(
                consolidateInvoiceDetails?.companyPanDetails,
                "borderRight",
                { md: 4.5 }
              )}

              {commonGridRender(
                consolidateInvoiceDetails?.companyInvoiceDetails,
                "NA",
                { md: 3 }
              )}
            </Grid>
          </Grid>
          <BillingConsolidatedInvoiceTable data={consolidateIvoiceList} />
        </Grid>
      )}
    </Grid>
  );
};

export default BillingConsolidateInvoice;
